import * as React from 'react';
import Row from '../Components/Row';
import Checkbox from '../Components/Checkbox';

// Tri-State to hide methods if null
export interface Communication {
  id: string;
  name: string;
  description: string;

  email?: boolean;
  post?: boolean;
  phone?: boolean;
  sms?: boolean;
}

export interface Props {
  title: string;
  introduction: string;
  disclaimer: string;
  communications: Communication[];
  headingColor?: string;

  communicationUpdated(id: string, type: 'email' | 'post' | 'phone' | 'sms', value: boolean): void;
}

export default class GdprModule extends React.PureComponent<Props> {
  render() {
    return (
      <>
        {this.renderTitle()}
        {this.renderIntroduction()}
        {this.renderCheckboxes()}
        {this.props.children}
        {this.renderDisclaimer()}
      </>
    );
  }

  private renderTitle = () => {
    let headingColorClass = '';
    if (this.props.headingColor) {
      headingColorClass = this.props.headingColor;
    }
    if (this.props.title) {
      return (<h5 className={headingColorClass}>{this.props.title}</h5>);
    }

    return null;
  }

  private renderIntroduction = () => {
    if (this.props.introduction) {
      return (<p>{this.props.introduction}</p>);
    }

    return null;
  }

  private renderDisclaimer = () => {
    if (this.props.disclaimer) {
      return (<p dangerouslySetInnerHTML={{ __html: this.props.disclaimer }} />);
    }

    return null;
  }

  private renderCheckboxes = () => {
    return this.props.communications.map((comm, index) => {
      return (
        <>
          <Row style={{ marginBottom: 0, marginTop: comm.name.length ? '10px' : 0 }}>
            <div className="col s12 m2 lg2 xl2 sidePaneConsent">{comm.name}</div>
            <div className="col s12 m10 lg10 xl10">
              {comm.description.length > 0 && (
                <>
                  {comm.description}
                  <br />
                  <br />
                </>
              )}

              {comm.email !== undefined && (
                <>
                  <Checkbox
                    id={'email' + index}
                    label="Email"
                    onChange={value => this.props.communicationUpdated(comm.id, 'email', value)}
                    checked={comm.email}
                  />
                  <br />
                </>
              )}

              {comm.post !== undefined && (
                <>
                  <Checkbox
                    id={'post' + index}
                    label="Post"
                    onChange={value => this.props.communicationUpdated(comm.id, 'post', value)}
                    checked={comm.post}
                  />
                  <br />
                </>
              )}

              {comm.phone !== undefined && (
                <>
                  <Checkbox
                    id={'phone' + index}
                    label="Phone"
                    onChange={value => this.props.communicationUpdated(comm.id, 'phone', value)}
                    checked={comm.phone}
                  />
                  <br />
                </>
              )}

              {comm.sms !== undefined && (
                <>
                  <Checkbox
                    id={'sms' + index}
                    label="SMS"
                    onChange={value => this.props.communicationUpdated(comm.id, 'sms', value)}
                    checked={comm.sms}
                  />
                  <br />
                </>
              )}
            </div>
          </Row>
        </>
      );
    });
  };
}



// WEBPACK FOOTER //
// ./src/Modules/GdprModule.tsx